var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dc_mypage" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("h1", [_vm._v("ニュース")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n          " + _vm._s(_vm.newsText) + "\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "infomation2" },
                  [
                    _c("h3", [_vm._v("新規情報")]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.viewNewsList, function(news, index) {
                        return _c(
                          "li",
                          {
                            key: "news-" + index,
                            staticClass: "news",
                            attrs: { value: _vm.product },
                            on: {
                              click: function($event) {
                                _vm.setNewsMessage(news.opInfoBody)
                              }
                            }
                          },
                          [
                            _c("div", [_vm._v(_vm._s(news.opInfoStartdt))]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(news.opInfoTitle))])
                          ]
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c("dd-pager", {
                      attrs: {
                        pageNo: _vm.pageNo,
                        dataCountPerPage: 4,
                        totalDataCount: _vm.newsList ? _vm.newsList.length : 0
                      },
                      on: { paging: _vm.paging }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a2fc2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a2fc2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcNews.vue
// module id = null
// module chunks = 